import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { calculateTrainAndShuttlePricesFromBooking, updatePaymentItemsForCancelBooking } from "../../../Lib/Utils/validationUtil";
import { cancelBookingTree } from "../../../Orchestrator/ConstantTree/CancelBookingPage/CancelBookingTree";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TripTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IBookingResponse, PassengerPriceDetails } from "../../../Orchestrator/Types/Index";


export class MainInboundCheckAction extends BaseAction<void, {
    allInboundFulFilledPass: PassengerPriceDetails[],
    passengerIds?: string[],
    booking: IBookingResponse,
    outboundChecked: boolean,
    inboundChecked: boolean
}> {
    async run(): Promise<void | null> {
        try {
            const { allInboundFulFilledPass, passengerIds, booking, outboundChecked, inboundChecked } = this.params!;
            if (inboundChecked == true) {
                let targetPassengerIds: string[] = [];
                if (passengerIds && passengerIds.length > 0) {
                    targetPassengerIds = passengerIds;
                    updateRecoilState("selectedPassengerForCancelInBoundAtom", passengerIds);
                } else {
                    targetPassengerIds = allInboundFulFilledPass.map((d) => d.pId.toString());
                    updateRecoilState("selectedPassengerForCancelInBoundAtom", targetPassengerIds);
                }
                
                // Calculate train and shuttle prices from booking data for selected passengers (inbound)
                const combinedPriceDetails = calculateTrainAndShuttlePricesFromBooking(
                    booking,
                    targetPassengerIds,
                    TripTypeEnum.IN_BOUND
                );
                
                const response = updatePaymentItemsForCancelBooking(combinedPriceDetails);
                updateRecoilState("paymentInboundItemsDetailsAtom", response);

                _eventBus.emit({
                    eventName: cancelBookingTree.CancelBooking.Init,
                    data: {
                        booking: booking,
                        filteredOutboundData: [],
                        filteredInboundData: targetPassengerIds,
                        outboundChecked: outboundChecked,
                        inboundChecked: inboundChecked
                    }
                });
            }
            else {
                updateRecoilState("selectedPassengerForCancelInBoundAtom", []);
                const response = updatePaymentItemsForCancelBooking([]);
                updateRecoilState("paymentInboundItemsDetailsAtom", response);
                _eventBus.emit({
                    eventName: cancelBookingTree.CancelBooking.Init,
                    data: {
                        booking: booking,
                        filteredOutboundData: [],
                        filteredInboundData: [],
                        outboundChecked: outboundChecked,
                        inboundChecked: inboundChecked
                    }
                });
            }

        } catch (error) {
            console.error("Error in PassengerInboundCheck action.:", error);
        }
    }
}

export const mainInboundCheckAction = new MainInboundCheckAction();